export function getSettingsPageTitle(settingsPage) {
  if (settingsPage === "account")          return "Account";
  if (settingsPage === "appearance")       return "Appearance";
  if (settingsPage === "datahub")          return "Data Hub";
  if (settingsPage === "preferences")      return "Preferences";
  if (settingsPage === "notifications")    return "Notifications";
  if (settingsPage === "journal")          return "My Journal";
  if (settingsPage === "privacy")          return "Legal";
  if (settingsPage === "privacy-policy")   return "Privacy Policy";
  if (settingsPage === "terms-of-service") return "Terms of Service";
  if (settingsPage === "feedback")         return "Support & Feedback";
  if (settingsPage === "change-password")  return "Change Password";
  return "Profile Settings";
}

export function getSettingsPageParent(settingsPage) {
  if (settingsPage === "privacy-policy")   return "privacy";
  if (settingsPage === "terms-of-service") return "privacy";
  if (settingsPage === "change-password")  return "home";
  return "home";
}